import firebase from 'firebase/app';
import 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyBsWesDeNo_RQWl4IdpIBE3peQMg3OXxio',
  authDomain: 'monsta-mls.firebaseapp.com',
  projectId: 'monsta-mls',
  storageBucket: 'monsta-mls.appspot.com',
  messagingSenderId: '322662453133',
  appId: '1:322662453133:web:058bb895f22cc92416b7c4',
  measurementId: 'G-LEN31DC06Q'
};

firebase.initializeApp(firebaseConfig);

if (firebase.messaging.isSupported()) {
  const messaging = firebase.messaging();

  messaging.usePublicVapidKey(
    'BMxnqE_1IfV5bNmgXEISEN0yBmhcpob-i8ZGU3J8x1OLBRSmiCILsg9hQvubaYwq41s_F8IqpYDJ_BEjP-ZaRrQ'
  );
}

export default firebase;
